<template>
    <div class="na-form">
        <div v-if="post" class="left">


            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">ID:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.PersonID' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldAcAff}}:</div>
                    <div class="dx-field-value">
                        <DxCheckBox :value='post.IsCurrentAffiliation' />
                    </div>
                </div>
                <!--<div class="dx-fieldset">
                    <div class="dx-field">
                        <div class="dx-field-label">DropDownBox with embedded TreeView</div>
                        <div class="dx-field-value">
                            <DxDropDownBox v-model:value="treeBoxValue"
                                           v-model:opened="isTreeBoxOpened"
                                           :show-clear-button="true"
                                           :data-source="treeDataSource"
                                           value-expr="ID"
                                           display-expr="name"
                                           placeholder="Select a value..."
                                           @value-changed="syncTreeViewSelection($event)">
                                <template #content="{ data }">
                                    <DxTreeView :ref="treeViewRefName"
                                                :data-source="treeDataSource"
                                                :select-by-click="true"
                                                data-structure="plain"
                                                key-expr="ID"
                                                parent-id-expr="categoryId"
                                                selection-mode="single"
                                                display-expr="name"
                                                @content-ready="$event.component.selectItem(treeBoxValue)"
                                                @item-selection-changed="treeView_itemSelectionChanged($event)"
                                                @item-click="onTreeItemClick($event)" />
                                </template>
                            </DxDropDownBox>
                        </div>
                    </div>-->
                    <div class="dx-field">
                        <div class="dx-field-label">Email:</div>
                        <div class="dx-field-value">
                            <DxTextBox :value='post.EMail' />
                        </div>

                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">{{tx.FieldCreatedOn}}:</div>
                        <div class="dx-field-value">
                            <DxDateBox :value='post.CreatedOn' :readOnly="true" />
                        </div>

                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">{{tx.FieldCreatedBy}}:</div>
                        <div class="dx-field-value">
                            <DxTextBox :value='post.CreatedBy' :readOnly="true" />
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">{{tx.FieldChangedOn}}:</div>
                        <div class="dx-field-value">
                            <DxDateBox :value='post.ChangedOn' :readOnly="true" />
                        </div>

                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">{{tx.FieldChangedBy}}:</div>
                        <div class="dx-field-value">
                            <DxTextBox :value='post.ChangedBy' :readOnly="true" />
                        </div>
                    </div>

                    <div class="na-buttons-row">

                        <div>
                            <DxButton 
                                      :text="btn.BtnSave"
                                      type="default"
                                      styling-mode="contained"
                                      @click="onClick($event)"
                                      onmouseover="this.style.backgroundColor='#006db9'" />
                        </div>
                        <div>
                            <DxButton
                                      :text="btn.BtnCancel"
                                      type="default"
                                      styling-mode="outlined"
                                      @click="onClick($event)" />
                        </div>
                        <div>
                        </div>


                    </div>
                </div>
            </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    //import DxDropDownBox from 'devextreme-vue/drop-down-box';
    //import DxTreeView from 'devextreme-vue/tree-view';
    import '../assets/detailForm.less';
    const baseUri = "WebApi.asmx/api/personService";
    export default {
        name: 'PersonDetail',
        components: {

            DxButton,
            DxTextBox,
            DxDateBox,
            DxCheckBox,
            //DxDropDownBox,
            //DxTreeView

        },
        data() {
            return {
                post: null,
                files: [],
                tx: {
                    FieldAcAff: this.$LanguageProvider.GetResource("FieldAcAff", "Caption", "Aktuelle Zugehörigkeit:"),
                    FieldCreatedBy: this.$LanguageProvider.GetResource("FieldCreatedBy", "Caption", "Erstellt von"),
                    FieldCreatedOn: this.$LanguageProvider.GetResource("FieldCreatedOn", "Caption", "Erstellt am"),
                    FieldChangedOn: this.$LanguageProvider.GetResource("FieldChangedOn", "Caption", "Geändert am"),
                    FieldChangedBy: this.$LanguageProvider.GetResource("FieldChangedBy", "Caption", "Geändert von"),
                },
                btn: {
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Speichern"),
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Abbrechen"),
                }
                //treeDataSource: null,
                //treeBoxValue: null,
                //treeViewRefName: 'tree-view',
             
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetailVx')
                .then(res => {
                    this.post = res.data.data

                })

        },
        methods: {
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>

    
</style>
